export { default } from "./Seo";
